import PropTypes from 'prop-types'
import React from 'react'
import { Outlet } from 'react-router-dom'
import usePushRouteChangeToGtm from '../../../hooks/usePushRouteChangeToGtm'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const RootLayoutModule = ({ children }) => {
  usePushRouteChangeToGtm()

  return children || <Outlet />
}

RootLayoutModule.propTypes = {
  children: PropTypes.node,
}

RootLayoutModule.defaultProps = {
  children: undefined,
}

export default RootLayoutModule
